export default "assets/images/cavalier-7c927b9d.svg";